import React, { useState } from 'react';
import styled from 'styled-components';
import { Input, Button } from '@blockstack/ui';
import Modal from './Modal';

import mediaQueries from './mediaQueries';
type Props = {};
const FeedbackFormContainer = styled.div`
    width: 100%;
    @media ${mediaQueries.laptop} {
    }
`;

const LeaveFeedback = styled.a`
    font-size: 14px;
    transition: all 0.2s ease-in-out;

    &:hover {
        transition: font 1s ease;
        font-size: 20px;
    }

    @media ${mediaQueries.laptop} {
        font-size: 18px;
    }
`;

const FeedbackMessage = styled.div`
    width: max-content;
`;

const encode = (data: any) => {
    return Object.keys(data)
        .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
        .join('&');
};

export const FeedbackForm: React.FC<Props> = () => {
    const [showFeedbackFrom, setShowFeedbackForm] = useState(false);
    const [feedbackFormSubmitted, setFeedbackFormSubmitted] = useState(false);

    return (
        <FeedbackFormContainer>
            {!showFeedbackFrom && !feedbackFormSubmitted && (
                <LeaveFeedback
                    href="#"
                    onClick={() => {
                        setShowFeedbackForm(true);
                    }}
                >
                    Leave a Feedback
                </LeaveFeedback>
            )}
            <Modal isOpen={showFeedbackFrom} onClose={() => setShowFeedbackForm(false)} title="Feedback">
                <>
                    {feedbackFormSubmitted ? (
                        <FeedbackMessage>Thank you for the feedback</FeedbackMessage>
                    ) : (
                        <form
                            name="feedback"
                            key={'feedback'}
                            data-netlify="true"
                            data-netlify-honeypot="bot-field"
                            onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
                                setFeedbackFormSubmitted(true);
                                const formData = {
                                    // @ts-ignore
                                    message: e.target[0].value,
                                    // @ts-ignore
                                    email: e.target[1].value,
                                };

                                fetch('/', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                    body: encode({ 'form-name': 'feedback', ...formData }),
                                });

                                e.preventDefault();
                            }}
                        >
                            <Input
                                type="text"
                                name="message"
                                pattern="\S+"
                                // @ts-ignore
                                required={true}
                                placeholder="Your feedback (optional)"
                                style={{ width: '300px', marginBottom: '15px' }}
                            />
                            <Input
                                type="email"
                                name="email"
                                placeholder="Your email"
                                style={{ width: '300px', marginBottom: '30px' }}
                            />
                            <div style={{ textAlign: 'center' }}>
                                <Button type="submit" style={{ marginRight: '15px' }}>
                                    Send
                                </Button>
                            </div>
                        </form>
                    )}
                </>
            </Modal>
        </FeedbackFormContainer>
    );
};

export default FeedbackForm;
